<h4 class="text-amazone-orange ms-6 mb-2 font-bold">{{ title }}</h4>
<div class="max-h-64 overflow-y-auto border border-gray-100 rounded-sm shadow-md">
  <dl class="text-gray-900 py-2 px-6">
    @for (report of getSortedReports(); track $index) {
      <div class="flex flex-col pb-3">
        <dt class="mb-1 text-gray-500 text-sm">
          {{ commonUtils.logLevelToIcon(report.logLevel) }} {{ report.languageCode }}
        </dt>
        <dd
          [ngClass]="commonUtils.logLevelToColor(report.logLevel)"
          class="text-sm font-semibold rounded-sm px-2 flex items-center gap-2"
        >
          <span> {{ report.code ? report.code + ' - ' : '' }}{{ report.message }} </span>
          @if (report.filename) {
            <span class="ms-4"><strong>File:</strong> {{ report.filename }}</span>
          }
        </dd>
      </div>
    }
  </dl>
</div>
